/* js/flipbook.js */

;(function($, window, document) {

    $(document).on('ready', function() {

        var $trigger = $('.open--flipbook'),
            $book = $('.flipbook--overlay'),
            $close = $('.flipbook--overlay-close'),
            $container = $('.flip-book-container'),
            openCls = 'is--open',
            overflowHidden = 'overflow--hidden';

        $trigger.on('click', function (event) {
            event.preventDefault();

            $book.addClass(openCls);
            $('body,html').addClass(overflowHidden);

            var href = '/' + $(this).attr('data-src');

            $container.attr('src', href);

            var options = {
                pdf: href, // you should use this property or pageCallback and pages to specify your book
                pages: 1,
                cmdSinglePage: true,
                pdfLinks: {
                    handler: function(type, destination) { // type: 'internal' (destination - page number), 'external' (destination - url)
                        return true; // true - prevent default handler, false - call default handler
                    }
                }
            };

            $container.FlipBook(options);
        });

        $close.on('click', function () {
            $('body,html').removeClass(overflowHidden);
            $book.removeClass(openCls);
            $container.attr('src', null);
        });

    });

})(jQuery, window, document);